export interface MQTTEvent<T = unknown> {
  type: string;
  timestamp: string;
  payload: T;
}

// Event types
export const EVENT_TYPES = {
  USER_CREATED: 'user.created',
  USER_UPDATED: 'user.updated',
  USER_DELETED: 'user.deleted',
  USER_BLOCKED: 'user.blocked',
  USER_LOGOUT: 'user.logout',
  USER_GROUPS_CHANGED: 'user.groups_changed',
  GROUP_CREATED: 'group.created',
  GROUP_UPDATED: 'group.updated',
  GROUP_DELETED: 'group.deleted',
  HEARTBEAT: 'heartbeat',
  HEARTBEAT_ACK: 'heartbeat.ack',
  // Feed sync events
  FEED_SYNC_STARTED: 'feed.sync.started',
  FEED_SYNC_COMPLETED: 'feed.sync.completed',
  FEED_SYNC_FAILED: 'feed.sync.failed',
  // Entity delete events
  DEVELOPER_DELETED: 'developer.deleted',
  RESIDENTIAL_COMPLEX_DELETED: 'residential_complex.deleted',
  APARTMENT_DELETED: 'apartment.deleted',
  FEED_DELETED: 'feed.deleted',
} as const;

export type EventType = typeof EVENT_TYPES[keyof typeof EVENT_TYPES];

// Event payloads
export interface UserCreatedPayload {
  user_id: string;
  login: string;
}

export interface UserUpdatedPayload {
  user_id: string;
  changes: Record<string, unknown>;
}

export interface UserGroupsChangedPayload {
  user_id: string;
  groups: string[];
}

export interface UserBlockedPayload {
  user_id: string;
  old_status: string;
  new_status: string;
  action: string;
  reason: string;
}

export interface HeartbeatAckPayload {
  session_id: string;
  success: boolean;
  error: string;
  server_time: string;
}

// Feed sync payloads
export interface FeedSyncStartedPayload {
  feed_id: string;
  developer_id: string;
}

export interface FeedSyncCompletedPayload {
  feed_id: string;
  developer_id: string;
  total_offers: number;
  new_apartments: number;
  updated: number;
  inactive: number;
  errors: number;
}

export interface FeedSyncFailedPayload {
  feed_id: string;
  error: string;
}

// Entity delete payloads
export interface DeveloperDeletedPayload {
  developer_id: string;
}

export interface ResidentialComplexDeletedPayload {
  residential_complex_id: string;
}

export interface ApartmentDeletedPayload {
  apartment_id: string;
}

export interface FeedDeletedPayload {
  feed_id: string;
}
